import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const LoyaltyBanner = () => (
  <section className="py-16 md:py-20" data-testid="loyalty-banner">
    <div className="max-w-5xl mx-auto px-5">
      <div
        className="relative rounded-[32px] p-8 md:p-14 overflow-hidden"
        style={{ background: "linear-gradient(135deg,#ffe6ec 0%,#fff5d6 55%,#ffd8e2 100%)" }}
      >
        <div className="relative grid md:grid-cols-[1fr_auto] gap-6 items-center">
          <div className="text-center md:text-left">
            <span className="text-xs uppercase tracking-[0.24em] text-coral font-medium">Carte fidélité gratuite</span>
            <h2 className="font-display text-3xl md:text-5xl mt-3 leading-[1.1]">
              Plus tu craques,<br />
              <span className="italic text-coral">plus on te gâte ♡</span>
            </h2>
            <p className="mt-4 text-amyu-muted text-sm md:text-base">
              10 visites = <span className="font-medium text-amyu-ink">1 tiramisu offert</span>. Ta carte reste toujours avec toi.
            </p>
            <div className="mt-5 grid grid-cols-10 gap-1.5 md:gap-2 max-w-md mx-auto md:mx-0">
              {Array.from({ length: 10 }).map((_, i) => (
                <div key={i} className="aspect-square relative" aria-hidden>
                  <svg viewBox="0 0 64 42" className="absolute inset-0 w-full h-full">
                    <path
                      d="M14 34 C6 34 2 28 6 22 C3 15 9 9 16 12 C17 4 28 2 32 9 C36 2 47 4 48 12 C55 9 61 15 58 22 C62 28 58 34 50 34 Z"
                      fill="rgba(255,255,255,0.7)"
                      stroke="rgba(229,91,91,0.4)"
                      strokeWidth={1.2}
                      strokeDasharray="3 3"
                    />
                  </svg>
                </div>
              ))}
            </div>
          </div>
          <Link
            to="/carte-fidelite"
            data-testid="loyalty-cta"
            className="btn-coral inline-flex items-center gap-2 justify-center whitespace-nowrap self-center md:self-end"
          >
            Créer ma carte <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </div>
  </section>
);
